import { TextInput } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import React from 'react';

const ClienteDadosGeraisEmpresaEstrangeira = ({
  id,
  name,
  values = {},
  errors = {},
  touched = {},
  onChange,
  onBlur,
}) => {
  return (
    <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
      <TextInput
        id={`${id}.identificadorEstrangeiro`}
        name={`pessoa.empresaEstrangeira.identificadorEstrangeiro`}
        onChange={onChange}
        onBlur={onBlur}
        value={values?.identificadorEstrangeiro}
        error={errors.identificadorEstrangeiro}
        touched={touched.identificadorEstrangeiro}
        fullWidth
        variant="outlined"
        label="Identificador estrangeiro"
        maxLength={15}
      />
    </Grid>
  );
};

export default ClienteDadosGeraisEmpresaEstrangeira;
